<template>
    <SettingsSection :section="section" :index="index" :level="level" :isLoading="isLoading" :initiated="initiated"
        @debounceSave="debouncedAutoSave()" @instantSave="saveSettings">
        <template v-slot:settingList>
            <SettingRow v-for="setting in section.settingList" :key="section.key + setting.settingKey"
                :setting="setting" :loaded="!isLoading && initiated" :fetchLoading="isLoading"
                @debounceSave="debouncedAutoSave()" @instantSave="saveSettings">
                <template v-if="setting.settingKey === 'Integration.ErpExportAssembly'" v-slot:component>
                    <v-select v-model="setting.value" :items="erpExportPlugins" item-text="Text" item-value="Key"
                        :label="setting.label" :loading="pluginsLoading" :clearable="true"
                        @change="onPluginSelected(setting)">
                    </v-select>
                </template>
            </SettingRow>
        </template>
    </SettingsSection>
</template>


<script>
import Vue from 'vue';
import clientAPI from "@/api/ClientAPIMixin";
import Section from "./Section.js"
import SettingRow from "./SettingRow.vue";
const SettingsSection = () => import("./SettingsSection.vue");

export default {
    name: "ErpExportSection",
    props: {
        section: Section,
        index: Number,
        level: Number,
        isLoading: Boolean,
        initiated: Boolean,
    },
    components: {
        SettingsSection,
        SettingRow,
    },
    mixins: [clientAPI],

    data() {
        return {
            erpExportPlugins: [],
            pluginsLoading: false,
        };
    },

    mounted() {
        this.fetchErpExportPlugins();
    },

    methods: {
        fetchErpExportPlugins() {
            this.pluginsLoading = true;
            clientAPI.methods.getErpExportPlugins()
                .then(response => {
                    this.erpExportPlugins = response || [];
                })
                .finally(() => {
                    this.pluginsLoading = false;
                });
        },

        onPluginSelected(setting) {
            Vue.set(setting, '_dirty', true);
            this.$emit('instantSave', [setting]);
        },

        saveSettings(settingsArr) {
            this.$emit('instantSave', settingsArr);
        },

        debouncedAutoSave() {
            this.$emit('debounceSave');
        },
    },

    computed: {},

    watch: {},
};
</script>


<style lang="scss" scoped></style>
